import { render, staticRenderFns } from "./VesselData.vue?vue&type=template&id=4e804697&scoped=true&"
import script from "./VesselData.vue?vue&type=script&lang=js&"
export * from "./VesselData.vue?vue&type=script&lang=js&"
import style0 from "./VesselData.vue?vue&type=style&index=0&id=4e804697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e804697",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer,VDataTable,VIcon,VSpacer})
